import { Routes } from '@angular/router';
import { RenderInterfaceGuard } from 'viggo-sistemas-core-web';

export const routesAdminExpedicao: Routes = [
  {
    path: 'combustivel',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      module: 'EXP_COMBUSTIVEL',
      menuKey: 'CONFIGURACOES',
      subMenuKey: 'EXPEDICAO',
      breadcrumb: {
        label: 'Combustível',
        icon: 'mdi mdi-gas-station-outline'
      }
    },
    loadChildren: () =>
      import('@modules/combustivel/combustivel.module').then(
        m => m.CombustivelModule
      )
  },
  {
    path: 'marca',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      module: 'EXP_MARCA',
      menuKey: 'CONFIGURACOES',
      subMenuKey: 'EXPEDICAO',
      breadcrumb: {
        label: 'Marca',
        icon: 'mdi mdi-marker-check'
      }
    },
    loadChildren: () =>
      import('@modules/marca/marca.module').then(m => m.MarcaModule)
  },
  {
    path: 'tipos_servicos_correios',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      module: 'EXP_TP_CORREIOS',
      menuKey: 'CONFIGURACOES',
      subMenuKey: 'EXPEDICAO',
      breadcrumb: {
        label: 'Tipo de serviço dos correios',
        icon: 'mdi mdi-mailbox-outline'
      }
    },
    loadChildren: () =>
      import(
        '@modules/tipo_servico_correios/tipo_servico_correios.module'
      ).then(m => m.TipoServicoCorreioModule)
  },
  {
    path: 'proprietario_veiculo',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      module: 'EXP_PROPRIETARIO',
      menuKey: 'CONFIGURACOES',
      subMenuKey: 'EXPEDICAO',
      breadcrumb: {
        label: 'Proprietário de veículo',
        icon: 'mdi mdi-car-key'
      }
    },
    loadChildren: () =>
      import('@modules/proprietario_veiculo/proprietario_veiculo.module').then(
        m => m.ProprietarioVeiculoModule
      )
  },
  {
    path: 'modelo_transporte',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      module: 'EXP_MODELO_TRANSP',
      menuKey: 'CONFIGURACOES',
      subMenuKey: 'EXPEDICAO',
      breadcrumb: {
        label: 'Modelo de transporte',
        icon: 'mdi mdi-car-outline'
      }
    },
    loadChildren: () =>
      import('@modules/modelo_transporte/modelo_transporte.module').then(
        m => m.ModeloTransporteModule
      )
  },
  {
    path: 'motorista',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      module: 'EXP_MOTORISTA',
      menuKey: 'CONFIGURACOES',
      subMenuKey: 'EXPEDICAO',
      breadcrumb: {
        label: 'Motorista',
        icon: 'mdi mdi-card-account-details-outline'
      }
    },
    loadChildren: () =>
      import('@modules/motorista/motorista.module').then(m => m.MotoristaModule)
  },
  {
    path: 'veiculo',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      module: 'EXP_VEICULO',
      menuKey: 'CONFIGURACOES',
      subMenuKey: 'EXPEDICAO',
      breadcrumb: {
        label: 'Veículo',
        icon: 'mdi mdi-car'
      }
    },
    loadChildren: () =>
      import('@modules/veiculo/veiculo.module').then(m => m.VeiculoModule)
  },
  {
    path: 'gerar_expedicao',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      module: 'EXPEDICAO',
      menuKey: 'CONFIGURACOES',
      subMenuKey: 'EXPEDICAO',
      breadcrumb: {
        label: 'Gerar expedição',
        icon: 'mdi mdi-notebook-plus-outline'
      }
    },
    loadChildren: () =>
      import('@modules/expedicao/expedicao.module').then(m => m.ExpedicaoModule)
  }
];
